import classNames from 'classnames';
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutlet,
  useParams,
} from 'react-router-dom';
import { SpaceView } from '~/routes/spaces/[id]';

export default function SiteSpaceLayout() {
  const outlet = useOutlet();
  const { spaceId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('..');
  };

  const isCalendarView = location.pathname.includes('/jobs/calendar');
  const isEditForm = location.pathname.endsWith('/edit');
  const shouldSpaceViewTakeFullWidth = !outlet;

  return (
    <div className='relative flex h-full'>
      <div
        className={classNames('flex-1', {
          'w-full': shouldSpaceViewTakeFullWidth,
          'xl:w-rsb xl:flex-none': !shouldSpaceViewTakeFullWidth,
        })}
      >
        <SpaceView />
      </div>
      {outlet && (
        <div
          className={classNames(
            'absolute z-50 h-full w-full xl:w-[414px]',
            !isCalendarView && !isEditForm ? 'xl:relative' : ''
          )}
        >
          <Outlet />
        </div>
      )}
    </div>
  );
}
